export default __webpack_public_path__ + "static/media/Icon-linkedin.63645749.svg";